import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('medical_benefits_set_review', '/medical_benefits_set_reviews', 'review')
const actions = generator.generate()

export default actions
